import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Link, navigate  } from "gatsby";
import UserContext, { User } from "../contexts/UserContext";

const SigninPage: React.FC = () => {
  const { register, handleSubmit, errors } = useForm();
  const {setUser} = useContext(UserContext);
  const onSubmit = async (data: { Username: string; Password: string }) => {
    try {
      const response = (await axios.post(`${process.env.GATSBY_STRAPI_URL}/auth/local`, {
        identifier: data.Username,
        password: data.Password,
      })) as { data: { user: string; jwt: string } };

      const strapiUser = response.data.user;
      const signedUser: User = {
        id: strapiUser["id"],
        username: strapiUser["username"],
        email: strapiUser["email"],
        token: response.data.jwt,
      };
      setUser(signedUser);
      navigate('/')
    } catch (error) {
      console.log("error is", error);
    }
  };

  return (
    <div className="w-screen h-screen bg-gray-500 flex flex-col justify-center items-center">
      <div className="w-4/5 h-auto bg-white p-4 rounded">
        <span>Se connecter</span>
        <form
          className="flex h-full flex-col mt-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            className="mt-4 p-2 focus:outline-none focus:border-2"
            type="text"
            placeholder="Username"
            name="Username"
            ref={register}
          />

          <input
            className="mt-4 p-2"
            type="password"
            placeholder="Password"
            name="Password"
            ref={register({ required: true })}
          />
          {errors.errorMessage && errors.errorMessage.message}
          <Link to="/signup" className="mt-4">
            Créer un compte
          </Link>          
          <Link to="/forgotten-password" className="mt-4">
            Mot de passe oublié
          </Link>
          <input className="mt-6 p-2" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default SigninPage;
